<template>
    <button class="ssv-order__participant-item ssv-order__participant-item--add-item" v-on:click="increase()" v-if="canIncreaseSeat">
        <span class="button button--link">Přidat účastníka</span>
    </button>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'SsvOrderParticipantAdd',
        computed: {
            ...mapGetters('ssvOrder', ['numberOfParticipants', 'course', 'courseDate']),
            canIncreaseSeat() {
                const {numberOfVacancies} = this.courseDate; // Počet volných míst
                const {priceForNumberOfParticipants} = this.course; // Cena pro X pracovníků
                let maximumParticipations = numberOfVacancies;

                if (priceForNumberOfParticipants > 1 && priceForNumberOfParticipants <= numberOfVacancies) {
                    maximumParticipations = priceForNumberOfParticipants; // Limitace počtu účastníků dle zbývajících míst
                }

                return this.numberOfParticipants < maximumParticipations ? true : false;
            }
        },
        methods: {
            ...mapActions('ssvOrder', ['increaseParticipant']),
            increase() {
                this.increaseParticipant();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/participant/ParticipantAdd.vue